import { Component, computed, inject } from "@angular/core";
import { SubmitProposalStateService } from "@app/features/submit-proposal/services/submit-proposal-state.service";
import { StatusMessageComponent } from "@app/shared/components/status-message.component";
import {
  GenericDataListItem,
  GenericDataTableComponent,
} from "@shared/components/generic-data-table/generic-data-table.component";

@Component({
  selector: "pa-submit-proposal-left-choice",
  templateUrl: "./submit-proposal-left-choice.component.html",
  styleUrls: ["./submit-proposal-left-choice.component.scss"],
  imports: [GenericDataTableComponent, StatusMessageComponent],
})
export class SubmitProposalLeftChoiceComponent {
  private readonly submitProposalStateService = inject(SubmitProposalStateService);
  protected submitInfo = this.submitProposalStateService.submitInfo;
  protected messages = this.submitProposalStateService.messages;

  protected dataList = computed<GenericDataListItem[]>(() => {
    // Re-initialize the dataList
    const submitInfo = this.submitInfo();
    return submitInfo ? this.submitProposalStateService.buildInfoTable() : [];
  });
}
